import styleUtils from "../styles/utils.module.css";

const PrivacyPage = () => {
  return (
    <>
      <h1 className={`${styleUtils.blockCenter} ${styleUtils.flexCenter}`}>
        Privacy Policy
      </h1>
      <br />
      <h5
        className={`${styleUtils.blockCenter} ${styleUtils.flexCenter}`}
        style={{ fontWeight: "400" }}
      >
        We care about your privacy (I swear) 🥺!
      </h5>
    </>
  );
};

export default PrivacyPage;
